import { render, staticRenderFns } from "./review-report.vue?vue&type=template&id=263f67cd&scoped=true"
import script from "./review-report.vue?vue&type=script&lang=js"
export * from "./review-report.vue?vue&type=script&lang=js"
import style0 from "./review-report.vue?vue&type=style&index=0&id=263f67cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263f67cd",
  null
  
)

export default component.exports